import React from 'react';
import {
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterIcon,
  TwitterShareButton,
  VKIcon,
  VKShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';

import { useRouter } from 'next/router';
import { config } from '../../config/config';

export const SocialShareButtons: React.FC = () => {
  const router = useRouter();

  const fullUrl = `${config.domain}${router.asPath}`;
  return (
    <>
      <TwitterShareButton url={fullUrl}>
        <TwitterIcon path={undefined} size={32} round />
      </TwitterShareButton>
      <FacebookShareButton url={fullUrl}>
        <FacebookIcon path={undefined} size={32} round />
      </FacebookShareButton>
      <RedditShareButton url={fullUrl}>
        <RedditIcon path={undefined} size={32} round />
      </RedditShareButton>
      <WhatsappShareButton url={fullUrl}>
        <WhatsappIcon path={undefined} size={32} round />
      </WhatsappShareButton>
      <FacebookMessengerShareButton url={fullUrl} appId="1607923582824195">
        <FacebookMessengerIcon path={undefined} size={32} round />
      </FacebookMessengerShareButton>
      <VKShareButton url={fullUrl}>
        <VKIcon path={undefined} size={32} round />
      </VKShareButton>
    </>
  );
};
